import { useEffect, useContext, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import { Nav, PrivateRoute, ProtectedRoute } from '_components';
import { Home } from 'home';
import { Login } from 'login';
import { OrganizationSettings } from 'organization-settings';
import { Shaping } from 'shaping';
import { Profile } from 'profile';
import { Admin } from 'admin';
import { Lists } from 'lists';
import { DdosGuard } from 'ddosguard';
import { Logs } from 'logs';
import { Backups } from 'backups';
import { NoPermission } from 'no-permission';
import { Callback } from 'callback';
import { AuthContext } from '_store';

export { App };

function App() {
    const { authUser, loading, setSelectedOrganization } = useContext(AuthContext);
    const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

    useEffect(() => {
        if (!authUser && !loading) {
            setSelectedOrganization('');
        }
    }, [authUser, loading, setSelectedOrganization]);


    return (
        <div className="app-container bg-background">
            {authUser && <Nav authUser={authUser} collapsed={sidebarCollapsed} onToggle={() => setSidebarCollapsed(v => !v)} />}
            <div className={authUser ? `min-h-screen transition-all duration-[250ms] ${sidebarCollapsed ? 'ml-[5rem]' : 'ml-[5rem] md:ml-56'}` : ''}>
                <Routes>
                    <Route
                        path="/"
                        element={
                            <PrivateRoute>
                                <Home />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/shaping"
                        element={
                            <PrivateRoute>
                                <Shaping />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/lists"
                        element={
                            <PrivateRoute>
                                <Lists />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/ddos-guard"
                        element={
                            <PrivateRoute>
                                <DdosGuard />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/logs"
                        element={
                            <PrivateRoute>
                                <Logs />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/backups"
                        element={
                            <PrivateRoute>
                                <Backups />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/profile"
                        element={
                            <PrivateRoute>
                                <Profile />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/organization-settings"
                        element={
                            <PrivateRoute>
                                <OrganizationSettings />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/admin"
                        element={
                            <PrivateRoute>
                                <ProtectedRoute requiredRoles={['admin']}>
                                    <Admin />
                                </ProtectedRoute>
                            </PrivateRoute>
                        }
                    />
                    <Route path="/login" element={<Login />} />
                    <Route path="/callback" element={<Callback />} />
                    <Route path="/no-permission" element={<NoPermission />} />
                    <Route path="*" element={<Navigate to="/" />} />
                </Routes>
            </div>
        </div>
    );
}
